import { Box, Flex, Heading, Icon, SimpleGrid, Text } from "@chakra-ui/react";
import { RootState, useAppSelector } from "../../../store";
import { formatDate } from "../../../helpers/formatDate";
import { ViewInformationBlock } from "@/components/ViewInformationBlock/ViewInformationBlock";
import { FiBriefcase } from "react-icons/fi";

 

export const SingleCustomerBlock = () => {
  const { currentCustomer } = useAppSelector(
    (state: RootState) => state.customers
  );

  return (
    <Flex flexDirection="column" gap="24px">
      <ViewInformationBlock icon={<Icon as={FiBriefcase as any} boxSize={5} color="#3b515e" />} title="Основная информация">
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
          <InfoItem label="Название" isBold={true}>
            {currentCustomer?.name ?? ""}
          </InfoItem>
          {Boolean((currentCustomer as any)?.inn) && (
            <InfoItem label="ИНН">{(currentCustomer as any)?.inn}</InfoItem>
          )}
          <InfoItem label="Сфера деятельности">
            {currentCustomer?.business_area?.name ?? ""}
          </InfoItem>
          <InfoItem label="Ответственный аккаунт-менеджер">
            {currentCustomer?.responsible_user?.username ?? ""}
          </InfoItem>
          <InfoItem label="Дата создания">
            {currentCustomer?.created_at && formatDate(currentCustomer.created_at)}
          </InfoItem>
        </SimpleGrid>
      </ViewInformationBlock>

      <ViewInformationBlock icon={<></>} title="Описание заказчика">
        <Text color="#4a5568" fontSize="14px" lineHeight="1.5" whiteSpace="pre-line">
          {(currentCustomer as any)?.description || "—"}
        </Text>
      </ViewInformationBlock>

      <ViewInformationBlock icon={<></>} title="Комментарий">
        <Text color="#4a5568" fontSize="14px" lineHeight="1.5" whiteSpace="pre-line">
          {currentCustomer?.comments || "—"}
        </Text>
      </ViewInformationBlock>
    </Flex> 

  );
};

const InfoItem = ({ label, children, isBold = false }: { label: string; children: any; isBold?: boolean }) => {
  return (
    <Flex flexDirection="column" gap="6px" minW={0}>
      <Flex alignItems="center" gap="8px">
        <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>{label}</Text>
      </Flex>
      <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={isBold ? 600 : 400}>{children ?? "—"}</Text>
    </Flex>
  );
};
